import Vue from 'vue'
import Router from 'vue-router'

// 使用懒加载优化性能
const Home = () => import('@/components/Home')
const HomeTV = () => import('@/components/HomeTV')
const IBC = () => import('@/components/IBC.vue')
const IBCTV = () => import('@/components/IBCTV.vue')
const IBC2 = () => import('@/components/IBC2.vue')
const Index = () => import('@/components/Index.vue')
const Phone = () => import('@/components/Phone.vue')
const Phone2 = () => import('@/components/Phone2.vue')
const Phone3 = () => import('@/components/Phone3.vue')
const Phone20 = () => import('@/components/Phone20.vue')
const Phone30 = () => import('@/components/Phone30.vue')
const IBCMall = () => import('@/components/IBCMall.vue')
const IBCMallWS = () => import('@/components/IBCMallWS.vue')
const WS = () => import('@/components/WS.vue')
const IBCWS = () => import('@/components/IBC_WS.vue')
const IBCTVWS = () => import('@/components/IBCTV_WS.vue')
const IBC2WS = () => import('@/components/IBC2_WS.vue')
const YGTD = () => import('@/components/YGTD.vue')
const YGTDTEL = () => import('@/components/YGTDTEL.vue')
const BAK = () => import('@/components/BAK.vue')
const PhoneHttp = () => import('@/components/PhoneHttp.vue')
const Phone30Http = () => import('@/components/Phone30Http.vue')
const DZH = () => import('@/components/DZH.vue')
const DZH1 = () => import('@/components/DZH1.vue')
const YFC = () => import('@/components/YFC.vue')
const YFC1 = () => import('@/components/YFC1.vue')
const YFCTEL = () => import('@/components/YFCTEL.vue')
const YGTDWS = () => import('@/components/YGTDWS.vue')
const PhoneCopy = () => import('@/components/PhoneCopy.vue')
const Phone20WS = () => import('@/components/Phone20WS.vue')
const YFC2 = () => import('@/components/YFC2.vue')
const PhoneC = () => import('@/components/PhoneC.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/tel',
      name: 'phone',
      component: Phone
    },
    {
      path: '/telcopy',
      name: 'phonecopy',
      component: PhoneCopy
    },
    {
      path: '/tel2',
      name: 'phone2',
      component: Phone2
    },
    {
      path: '/tel3',
      name: 'phone3',
      component: Phone3
    },
    {
      path: '/tel20',
      name: 'phone20',
      component: Phone20
    },
    {
      path: '/tel20ws',
      name: 'phone20ws',
      component: Phone20WS
    },
    {
      path: '/tel30',
      name: 'phone30',
      component: Phone30
    },
    {
      path: '/tel30http',
      name: 'phone30Http',
      component: Phone30Http
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/tv',
      name: 'tv',
      component: HomeTV
    },
    {
      path: '/ibc',
      name: 'IBC',
      component: IBC
    },
    {
      path: '/ibcws',
      name: 'IBCWS',
      component: IBCWS
    },
    {
      path: '/ibc2',
      name: 'IBC2',
      component: IBC2
    },
    {
      path: '/ibc2ws',
      name: 'IBC2WS',
      component: IBC2WS
    },
    {
      path: '/ibcmall',
      name: 'IBCMall',
      component: IBCMall
    },
    {
      path: '/ibcmallws',
      name: 'IBCMallWS',
      component: IBCMallWS
    },
    {
      path: '/ibctv',
      name: 'IBCTV',
      component: IBCTV
    },
    {
      path: '/ibctvws',
      name: 'IBCTVWS',
      component: IBCTVWS
    },
    {
      path: '/ws',
      name: 'WS',
      component: WS
    },
    {
      path: '/ygtd',
      name: 'YGTD',
      component: YGTD
    },
    {
      path: '/ygtdtel',
      name: 'YGTDTEL',
      component: YGTDTEL
    },
    {
      path: '/bak',
      name: 'BAK',
      component: BAK
    },
    {
      path: '/telhttp',
      name: 'PhoneHttp',
      component: PhoneHttp
    },
    {
      path: '/dzh',
      name: 'DZH',
      component: DZH
    },
    {
      path: '/dzh1',
      name: 'DZH1',
      component: DZH1
    },
    {
      path: '/yfc',
      name: 'YFC',
      component: YFC
    },
    {
      path: '/yfc1',
      name: 'YFC1',
      component: YFC1
    },
    {
      path: '/yfc2',
      name: 'YFC2',
      component: YFC2
    },
    {
      path: '/yfctel',
      name: 'YFCTEL',
      component: YFCTEL
    },
    {
      path: '/ygtdws',
      name: 'YGTDWS',
      component: YGTDWS
    },
    {
      path: '/telo',
      name: 'PhoneC',
      component: PhoneC
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js